import { BottomButtonTemplateProps } from '../../types/bottomButtonTemplateProps';

export default function BottomButtonTemplate(props: BottomButtonTemplateProps): JSX.Element {
  return (
      <input
        type="button"
        value={props.text}
        className={`btn btn-secondary ${props.enabled ? 'active' : ''}`}
        disabled={!props.enabled}
        onClick={props.func}
      />
  );
}